import { render, staticRenderFns } from "./SelectHowToPay.vue?vue&type=template&id=92804fc0&"
import script from "./SelectHowToPay.vue?vue&type=script&lang=ts&"
export * from "./SelectHowToPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports